import React from 'react';

export default (NotificationTemplate, DefaultButton) => {
	return function achievementNotification(props) {
		return <NotificationTemplate {...props} button={DefaultButton} />;
	};
};
